import { render, staticRenderFns } from "./PromotionForm.vue?vue&type=template&id=532ce459"
import script from "./PromotionForm.vue?vue&type=script&lang=js"
export * from "./PromotionForm.vue?vue&type=script&lang=js"
import style0 from "./PromotionForm.vue?vue&type=style&index=0&id=532ce459&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports